<ng-container>
  <ng-container>
    <div class="help-text" *ngIf="showHelp">
      <div [innerHtml]="sanitizeContent"></div>
      <br>
      <ion-button color="primary" class="r" (click)="showTutorial()">Launch Tutorial</ion-button>
    </div>
      <div *ngIf="sanitizeContent || tutorials.length > 0" class="help-bubble" [class.pulse]="!showHelp" (click)="determineFunctionCall()">
        <div class="lbl">
          {{ showHelp ? 'Close' : 'Help!' }}
        </div>
      </div>
  </ng-container>
</ng-container>